import { Theme, useMediaQuery } from "@mui/material";
import { Fragment } from "react";
import { TextField, DatagridConfigurable, List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, BooleanInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { exporterExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_EXPORTER_C" />
        <SortButton fields={['name']} />
        <FilterButton />
        <SacopExportButton exporter={exporterExporter} />
    </TopToolbar>
);

const exporterFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput source="active" />,
    <TextInput source="name" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="name" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const ExporterList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        filterDefaultValues={ { active: true }}
        sort={{ field: 'name', order: 'DESC' }}
        perPage={25}
        filters={exporterFilters}
        actions={<ListActions />}
        exporter={exporterExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default ExporterList;
